import { type ReactNode, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster as ToastProvider } from 'react-hot-toast';
import { useTenantDocumentTitle } from 'hooks';
import { AuthContextProvider, ImpersonateProvider } from './context';
import { Router } from './modules';
import { initSentry } from './utils/sentry';

import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60, // 1 hour
      refetchOnWindowFocus: false,
    },
  },
});

const AppProviders = ({ children }: { children: ReactNode }) => {
  useTenantDocumentTitle();

  return (
    <AuthContextProvider>
      {children}
    </AuthContextProvider>
  );
};

export const App = () => {
  useEffect(() => {
    initSentry();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppProviders>
        <ToastProvider position="top-center" />
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        <ImpersonateProvider>
          <Router />
        </ImpersonateProvider>
      </AppProviders>
    </QueryClientProvider>
  );
};
